module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-rustic-6-updated-d78ae2aa5b208c00dc4c002f735136ba.webp";